export default [
  {
    PatientID: "100001",
    FirstName: "John",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "42681-7076",
            itemId: "03",
            binId: "A3",
            rxNo: "A123456",
            name: "365 Everyday Value Acetaminophen",
            description: "365 Everyday Value Acetaminophen",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "500 mg/1",
            route: "Oral",
            doseage_form: "Capsule",
            non_proprietary_name: "Amoxicillan",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100002",
    FirstName: "Paul",
    LastName: "Jones",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "42681-7075",
            itemId: "03",
            binId: "A3",
            rxNo: "A123457",
            name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 90,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "10 mg/1",
            route: "Oral",
            doseage_form: "Tablet",
            non_proprietary_name: "atorvastatin calcium",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100003",
    FirstName: "Nicole",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "42681-7077",
            itemId: "03",
            binId: "A3",
            rxNo: "A123458",
            name: "Eliquis 2.5 mg Tab",
            description: "Eliquis 2.5 mg Tab",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            strength: "500 mg/1",
            route: "Oral",
            doseage_form: "Tablet",
            non_proprietary_name: "valacyclovir hydrochloride",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100001",
    FirstName: "John",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "10202-0484",
            itemId: "03",
            binId: "A3",
            rxNo: "A123459",
            name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 15,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100002",
    FirstName: "Paul",
    LastName: "Jones",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "10202-0259",
            itemId: "03",
            binId: "A3",
            rxNo: "A123460",
            name: "lidocaine Top 4% Cream 30 gm",
            description: "lidocaine Top 4% Cream 30 gm",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100003",
    FirstName: "Nicole",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "10202-0416",
            itemId: "03",
            binId: "A3",
            rxNo: "A123461",
            name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 90,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100001",
    FirstName: "John",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "10202-0130",
            itemId: "03",
            binId: "A3",
            rxNo: "A123462",
            name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100002",
    FirstName: "Paul",
    LastName: "Jones",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "42507-0217",
            itemId: "03",
            binId: "A3",
            rxNo: "A123463",
            name: "Eliquis 2.5 mg Tab",
            description: "Eliquis 2.5 mg Tab",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 15,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100003",
    FirstName: "Nicole",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "16590-0323",
            itemId: "03",
            binId: "A3",
            rxNo: "A123464",
            name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
          {
            ndcCode: "51655-157",
            itemId: "03",
            binId: "A3",
            rxNo: "A123444",
            name: "lidocaine Top 4% Cream 30 gm",
            description: "lidocaine Top 4% Cream 30 gm",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100010",
    FirstName: "Michael",
    LastName: "Thomas",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "16590-0745",
            itemId: "03",
            binId: "A3",
            rxNo: "A123465",
            name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 90,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100011",
    FirstName: "Joseph",
    LastName: "Box",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "16590-0745",
            itemId: "03",
            binId: "A3",
            rxNo: "A123466",
            name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100012",
    FirstName: "Paul",
    LastName: "Patient",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "21695-0002",
            itemId: "03",
            binId: "A3",
            rxNo: "A123467",
            name: "Eliquis 2.5 mg Tab",
            description: "Eliquis 2.5 mg Tab",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 15,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100013",
    FirstName: "Paul",
    LastName: "Patient",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "21695-0003",
            itemId: "03",
            binId: "A3",
            rxNo: "A123468",
            name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100014",
    FirstName: "Bryan",
    LastName: "Rigney",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "24236-0279",
            itemId: "03",
            binId: "A3",
            rxNo: "A123469",
            name: "lidocaine Top 4% Cream 30 gm",
            description: "lidocaine Top 4% Cream 30 gm",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 90,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100015",
    FirstName: "Ivan",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "24236-0792",
            itemId: "03",
            binId: "A3",
            rxNo: "A123470",
            name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100016",
    FirstName: "Jonah",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "50742-189",
            itemId: "03",
            binId: "A3",
            rxNo: "A123471",
            name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 15,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100017",
    FirstName: "Grayson",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "51655-157",
            itemId: "03",
            binId: "A3",
            rxNo: "A123472",
            name: "Eliquis 2.5 mg Tab",
            description: "Eliquis 2.5 mg Tab",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 10,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100018",
    FirstName: "Gabriel",
    LastName: "Smith",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "0071-0155",
            itemId: "03",
            binId: "A3",
            rxNo: "A123473",
            name: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            description: "Mounjaro 7.5 mg/0.5 mL pen for injection",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 90,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100019",
    FirstName: "Vishal",
    LastName: "Zacharias",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "info@ilocalbox.com",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "55289-926",
            itemId: "03",
            binId: "A3",
            rxNo: "A123474",
            name: "lidocaine Top 4% Cream 30 gm",
            description: "lidocaine Top 4% Cream 30 gm",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
  {
    PatientID: "100060",
    FirstName: "Manav",
    LastName: "Pandya",
    DateOfBirth: "11/11/2011",
    MobileNo: "9497677339",
    EmailID: "manav.pandya@epistic.net",
    governmentIdNo: "",
    governmentIdType: "",
    relatives: [
      {
        patientId: "",
        relation: "",
      },
    ],
    orders: [
      {
        orderId: "03",
        pickupCode: "A3A3A3",
        totalAmount: 300,
        taxPercentage: 3,
        insuranceAmount: 20,
        totalCoPayAmount: 40,
        totalPaidAmount: 40,
        totalDueAmount: 0,
        paymentDueDate: "",
        items: [
          {
            ndcCode: "55289-926",
            itemId: "03",
            binId: "A3",
            rxNo: "Z123474",
            name: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            description: "losartan-hydrochlorothiazide 50-12.5 mg tablet",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
          {
            ndcCode: "55289-927",
            itemId: "03",
            binId: "A3",
            rxNo: "Z123475",
            name: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            description: "dextroamphetamine-amphetamine 20 mg extended release (24 hr) capsule",
            image: "/static/dashboard/global_assets/images/placeholders/placeholder-30.svg",
            potency: "500 mg/1",
            qty: 30,
            schedule: "",
            Amount: 5,
            taxPercentage: 3,
            insuranceAmount: 0,
            CoPayAmount: 5,
            PaidAmount: 5,
            DueAmount: 0,
            paymentDueDate: "",
            stockedOn: "",
            stockedBy: "",
            deStockedOn: "",
            ExpirationDate: "01/01/2020",
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/assets/rxData.js